import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function IsKaygisiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['is-kaygisi-testi']} />;
}
